import React, { Component } from 'react'

import { FaArrowCircleLeft } from 'react-icons/fa'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import DocumentacionNuevo from './DocumentacionNuevo'
import DocumentacionLegalLista from './DocumentacionLegalLista'
import { Divider, Grid, IconButton, Tooltip, Typography } from '@mui/material'

class DocumentacionLegal extends Component {

  
  
  handleGoBack = () => {
    const { clienteId } = this.props.match.params;
    const { credentials } = this.props.user;
   
        if (credentials.tipouser === 'Asistencial') {
          this.props.history.push('/dashboard/equiposasistencial');
        } else if (credentials.tipouser === 'Tecnico') {
          this.props.history.push(`/dashboard/perfilclientetec/${clienteId}`);
        } else {
          this.props.history.push(`/dashboard/perfilcliente/${clienteId}`);
        }
  };

  render() {

    const { credentials } = this.props.user;
    const isAsistencial = credentials.tipouser === 'Asistencial';

    return (
      <Grid container spacing={2}>
  {/* Título y botones */}
<Grid item xs={12}>
  <Grid
    container
    spacing={2}
    alignItems="center"
    justifyContent="space-between"
    direction={{ xs: 'column', md: 'row' }} // clave para responsive
  >
    {/* Título */}
    <Grid item xs={12} md="auto" ml={2}>
    <Typography
  variant="h5"
  sx={{
    mb: '10px',
    fontSize: '30px',
    lineHeight: 1.1,
    fontWeight: 550,
    color: '#03178c',
    mt: '10px'
  }}
>
  Documentación Legal
</Typography>
      <Divider className="clientes_separator" />
    </Grid>

    {/* Botones */}
    <Grid item xs={12} md="auto">
      <Grid
        container
        spacing={2}
        justifyContent={{ xs: 'center', md: 'flex-end' }}
        alignItems="center"
      >
        {!isAsistencial && (
                  <Grid item>
                    <DocumentacionNuevo clienteId={this.props.match.params.clienteId} />
                  </Grid>
                )}
        <Grid item>
          <Tooltip title="Volver">
            <IconButton onClick={this.handleGoBack}>
              <FaArrowCircleLeft color="#03178C" className="icon-eliminarcliente" />
            </IconButton>
          </Tooltip>
        </Grid>
      </Grid>
    </Grid>
  </Grid>
</Grid>

  {/* Lista de documentación */}
  <Grid item xs={12}>
    <div className="listaclientes_container">
      <DocumentacionLegalLista clienteId={this.props.match.params.clienteId} />
    </div>
  </Grid>
</Grid>
    )
  }
}

DocumentacionLegal.propTypes = {
  user: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  user: state.user
});

export default connect(mapStateToProps)(withRouter(DocumentacionLegal));